
import Vue from "vue";
import { NewCompanyUsersApiFunc, setAccessToken } from "@/api";
import { CompanyUser } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import CompanyUserEditor from "./components/CompanyUserEditor.vue";

export type DataType = {
  companyUser?: CompanyUser;
};

export default Vue.extend({
  name: "CompanyUserDetailScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    CompanyUserEditor,
  },

  data(): DataType {
    return {
      companyUser: undefined,
    };
  },

  computed: {},

  mounted() {
    this.getCompanyUser();
  },

  methods: {
    async getCompanyUser(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const companyUserId = this.$router.currentRoute.params.companyUserId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewCompanyUsersApiFunc().getCompanyUser(
        companyId,
        companyUserId
      );

      if (err != null) {
        this.$handleApiError(err, this.getCompanyUser);
        return;
      }

      this.companyUser = data;
    },

    async updateCompanyUser(companyUser: CompanyUser): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);

      const companyUserId = this.$router.currentRoute.params.companyUserId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewCompanyUsersApiFunc().updateCompanyUser(
        companyId,
        companyUserId,
        companyUser
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.updateCompanyUser(companyUser);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-users",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
